/* Mialica blog: scroll reveal for every blog section (main, guides, newsletter).
   14 Oct 2026: the previous version only looked inside the first .mialica-blog-archive,
   so the "Tre guide da salvare" and newsletter sections stayed invisible (opacity 0).
   It now covers every blog section, works if the script loads late, and in the theme editor. */
(function () {
  'use strict';

  if (window.mialicaBlogReveal) return;
  window.mialicaBlogReveal = true;

  var io = null;

  function show(el) {
    el.classList.add('is-visible');
  }

  function observe(scope) {
    var els = (scope || document).querySelectorAll('.mialica-blog-archive .mb-reveal:not(.is-visible)');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, show);
      return;
    }

    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            show(entry.target);
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });
    }

    Array.prototype.forEach.call(els, function (el) {
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { observe(document); });
  } else {
    observe(document);
  }

  /* Theme editor: a section that is added or changed is rendered again */
  document.addEventListener('shopify:section:load', function (event) {
    observe(event.target);
  });
})();
